import { Map } from 'immutable';
import {
  FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS,
} from './actions';
import AcademicInfoSummary from './model';

export default function academicInfoSummary(state = new Map(), action) {
  switch (action.type) {
    case FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS: {
      const model = new AcademicInfoSummary(action.payload);
      return state.set(`${model.groupId}`, model);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/AcademicInfo/Summary/reducer.js